// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1HC27","buttons":"SendReceipts_buttons__57Cjc","email":"SendReceipts_email__1CDHP","bookApptTitle":"SendReceipts_bookApptTitle__1gXEZ"};